import type { FC } from 'react';

import { useScreen } from '../../hooks/use-screen/use-screen';
import { SimpleCompanyCard } from '../simple-company-card/simple-company-card';
import * as Styled from './simple-company-card-grid.styled';

type SimpleCompanyCardGridSkeletonProps = {
  amountOfCards?: number;
};
export const SimpleCompanyCardGridSkeleton: FC<
  SimpleCompanyCardGridSkeletonProps
> = ({ amountOfCards = 3 }) => {
  const { isSmallScreen } = useScreen();

  return (
    <Styled.Grid data-testid="SIMPLE-COMPANY-CARD-GRID-SKELETON">
      {Array.from({ length: amountOfCards }).map((_, index) => (
        <SimpleCompanyCard.Skeleton
          key={`simpleCompanyCardSkeleton_${index}`}
          horizontal={isSmallScreen}
        />
      ))}
    </Styled.Grid>
  );
};
